import React, { Component } from "react";
import { POST, loading, token } from "../components/CustomComponent.js";
import LOGO from "../assets/images/logo-transparant-white.png"
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      password_view: "password",
      remember: false
    };
  }
  componentDidMount() {
    loading(false);
  }
  Login = async () => {
    loading(true);
    let result = await POST("login", {
      email: this.state.email,
      password: this.state.password,
      remember: this.state.remember,
    });
    if (result?.status) { 
      localStorage.setItem("scp-acc-tk", btoa("Bearer " + result.data.token));
      localStorage.setItem("scp-profile", JSON.stringify({...result.data, password: ""}));
      window.location.href = "/dashboard";
    }
    loading(false);
  };
  render() {
    return (
      <div className="w-100 min-vh-100 background">
        <div className="row">
          <div className="col-12 d-flex align-items-center justify-content-center d-md-none bg-primary py-3">
          <img alt="logo" src={LOGO} className="w-75" style={{minWidth:350}}/>
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
            <div className="col-11 col-md-10 col-lg-7 col-xl-6 mx-auto my-5">
            <h3 className="fw-bold text-primary mb-3">ยินดีต้อนรับ</h3>
            <div className="mb-3">กรุณากรอกอีเมลและรหัสผ่านเพื่อเข้าใช้งานระบบ</div>
            <label className="mb-1">อีเมล</label>
            <input className="form-control mb-3" type="text" placeholder="อีเมล" onChange={(e) => { this.setState({ email: e.target.value }); }} value={this.state.email}/>
            <label className="mb-1">รหัสผ่าน</label>
            <div className="position-relative">
              <input className="form-control mb-3" type={this.state.password_view} placeholder="รหัสผ่าน" onChange={(e) => { this.setState({ password: e.target.value });}} onKeyUp={(e) => { if (e.key === "Enter") { this.Login(); } }} value={this.state.password}/>
              <div className="wpx-40 hpx-40 d-flex justify-content-center align-items-center icon pointer position-absolute" style={{right:0, top:1}} onClick={() => {this.setState({password_view: this.state.password_view === "password" ? "text" : "password"})}}>{this.state.password_view === "password" ? "\uf06e" : "\uf070"}</div>
            </div>
            <div className="d-flex mb-3">
              <input type="checkbox" className="me-2" onChange={(e)=>{this.setState({remember:e.target.checked})}} checked={this.state.remember}/>
              <span>จดจำการเข้าสู่ระบบ</span>
            </div>
            <button type="button" className="btn btn-primary w-100 mb-3" onClick={() => { this.Login(); }}>เข้าสู่ระบบ</button>
            <div className="w-100 text-center">
              <small className="text-secondary text-center">Copyright © 2023 SmartCanePro version {process.env.REACT_APP_VERSION}</small>
            </div>
            </div>
          </div>
          <div className="col-6 d-none d-md-flex align-items-center justify-content-center bg-primary min-vh-100">
            <img alt="logo" src={LOGO} className="w-50" style={{minWidth:400}}/>
          </div>
        </div>
      </div>
    );
  }
}
